import { render, staticRenderFns } from "./red_talent.vue?vue&type=template&id=3a35460c&scoped=true"
import script from "./red_talent.vue?vue&type=script&lang=js"
export * from "./red_talent.vue?vue&type=script&lang=js"
import style0 from "./red_talent.vue?vue&type=style&index=0&id=3a35460c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35460c",
  null
  
)

export default component.exports